import List from "./List";
import Empty from "./Empty";

export default {
  List,
  Empty
};
